module.exports = __webpack_public_path__ + "static2023-4-17/img/rank.cb03dd72.png";